import { Button, Modal } from '@optimization/ssi-common';
import { ReactElement } from 'react';
import classes from './style.module.scss';
import VehicleImportOptionBox from './VehicleImportOptionBox';
import menuItems from '@/features/Solution/utils/solution-menu-items';
import useImportCandidateModal from '@/app/context/ImportCandidateModalContext/use-import-candidate-modal';

const ImportCandidateModal = (): ReactElement => {
  const { closeModal, modalTitle } = useImportCandidateModal();

  return (
    <Modal size="sm" header={modalTitle} onClose={closeModal}>
      <div className={classes['options-container']}>
        <h6>Choose how you would like to proceed</h6>
        {menuItems.map((item) => {
          const isDisabled = item.disabled ?? (item.title === 'Use customer name' && modalTitle === 'Add Candidates');

          return (
            <VehicleImportOptionBox
              key={item.title}
              modalTitle={modalTitle}
              optionTitle={item.title}
              optionDescription={item.description}
              optionIcon={item.icon}
              disabled={isDisabled}
            />
          );
        })}
      </div>

      <div className={classes['action-buttons-container']}>
        <Button size="sm" variant="secondary" text="Cancel" onClick={closeModal} />
      </div>
    </Modal>
  );
};

export default ImportCandidateModal;
